// @flow
import React from "react";
import type { IconProps } from "../";

type Props = {
  ...IconProps,
  className?: string,
  onClick?: () => void
};

export default function ModeLight({
  width = "18px",
  fill = "currentColor",
  ...props
}: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 17.998 18.002"
      fill={fill}
      width={width}
      {...props}
    >
      <path
        d="M-9908.881-12925.879v-1.407a.881.881,0,0,1,.88-.88.879.879,0,0,1,.881.88v1.407a.879.879,0,0,1-.881.88A.881.881,0,0,1-9908.881-12925.879Zm6-1.758-.993-.994a.878.878,0,0,1,0-1.244.879.879,0,0,1,1.244,0l.993,1a.873.873,0,0,1,0,1.24.877.877,0,0,1-.622.259A.881.881,0,0,1-9902.882-12927.637Zm-11.482,0a.879.879,0,0,1,0-1.244l.994-.994a.879.879,0,0,1,1.244,0,.878.878,0,0,1,0,1.244l-.994.994a.879.879,0,0,1-.622.259A.879.879,0,0,1-9914.364-12927.637Zm1.854-6.363a4.516,4.516,0,0,1,4.509-4.509,4.516,4.516,0,0,1,4.509,4.509,4.515,4.515,0,0,1-4.509,4.509A4.516,4.516,0,0,1-9912.51-12934Zm11.224.88a.881.881,0,0,1-.881-.88.879.879,0,0,1,.881-.88h1.406a.878.878,0,0,1,.88.88.88.88,0,0,1-.88.88Zm-14.835,0a.879.879,0,0,1-.877-.88.878.878,0,0,1,.877-.88h1.409a.878.878,0,0,1,.877.88.879.879,0,0,1-.877.88Zm12.246-5a.878.878,0,0,1,0-1.244l.993-.994a.882.882,0,0,1,1.248,0,.885.885,0,0,1,0,1.244l-1,.994a.879.879,0,0,1-.622.258A.876.876,0,0,1-9903.875-12938.125Zm-9.492,0-1-.994a.879.879,0,0,1,0-1.244.878.878,0,0,1,1.244,0l1,.994a.883.883,0,0,1,0,1.244.878.878,0,0,1-.623.258A.872.872,0,0,1-9913.367-12938.125Zm4.486-2.589v-1.406a.881.881,0,0,1,.88-.881.88.88,0,0,1,.881.881v1.406a.879.879,0,0,1-.881.88A.881.881,0,0,1-9908.881-12940.714Z"
        transform="translate(9916.998 12943.001)"
      />
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/components/Icons/Tools/ModeLight.js